import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function HeroTop() {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const animationRef = useRef<number | null>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        let width = (canvas.width = window.innerWidth);
        let height = (canvas.height = window.innerHeight);
        let time = 0;

        const lines = 30;
        const segments = 120;

        const draw = () => {
            ctx.clearRect(0, 0, width, height);
            ctx.strokeStyle = "rgba(99,102,241,0.55)";
            ctx.lineWidth = 1;

            for (let i = 0; i < lines; i++) {
                ctx.beginPath();
                for (let j = 0; j <= segments; j++) {
                    const x = (j / segments) * width;
                    const wave = Math.sin(j * 0.15 + time * 0.8 + i * 0.5);
                    const y =
                        height / 2 +
                        (i - lines / 2) * 18 +
                        wave * 25 * Math.sin(i * 0.2 + time * 0.6);
                    j === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                }
                ctx.stroke();
            }

            time += 0.012;
            animationRef.current = requestAnimationFrame(draw);
        };

        draw();

        const handleResize = () => {
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight;
        };
        window.addEventListener("resize", handleResize);

        return () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // ✅ Trigger chat widget
    const handleOpenChat = () => {
        window.dispatchEvent(new Event("open-chat"));
    };

    return (


        <section className="relative w-full min-h-[70vh] md:min-h-[80vh] bg-black z-[5] overflow-visible">

            {/* Canvas Background */}
            <div className="absolute inset-0 z-0 pointer-events-none">
                <canvas ref={canvasRef} className="w-full h-full block" />
            </div>

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80 pointer-events-none z-10" />

            {/* Hero Content */}

            <div className="relative z-20 max-w-5xl mx-auto px-6 py-20 sm:py-24 text-white text-center md:text-left">
                <motion.h1
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    className="text-4xl sm:text-5xl md:text-6xl font-bold"
                >
                    SecureID Technologies LLC
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 1, ease: "easeOut" }}
                    className="mt-4 max-w-2xl text-lg text-indigo-100/90 mx-auto md:mx-0"
                >
                    Identity & testing solutions for agencies and enterprises — biometric
                    Live Scan, background checks, exam platforms, and IVR consulting.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 1, ease: "easeOut" }}
                    className="mt-8 flex flex-wrap justify-center md:justify-start gap-4"
                >
                    <Link
                        to="/solutions"
                        className="rounded-full bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 font-semibold transition"
                    >
                        Explore Solutions
                    </Link>

                    <button
                        onClick={handleOpenChat}
                        className="rounded-full border border-indigo-300 text-indigo-100 px-6 py-3 font-semibold hover:bg-white/10 transition"
                    >
                        💬 Talk with our AI Agent
                    </button>
                </motion.div>
            </div>
        </section>
    );
}
